export default "__VITE_ASSET__4e376c3f__"